import { Component, EventEmitter, OnInit } from '@angular/core';
import { SharedConfirmationDialog } from '@shared/model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  items: string[] = [];
  header = '';
  message1 = '';
  message2 = '';
  acceptLabel = 'Accept';
  rejectLabel = 'Reject';
  acceptIcon = null;
  rejectIcon = null;
  action: string = null;
  accept: EventEmitter<void> = new EventEmitter();

  showMore = false;
  displayedItems: string[] = [];
  displayRejectButton = true;
  displayAcceptButton = true;

  constructor(public config: DynamicDialogConfig<Partial<SharedConfirmationDialog>>, public ref: DynamicDialogRef) { }

  ngOnInit(): void {
    if (this.config.data) {
      const {data} = this.config;
      this.items = data.items || [];
      this.displayedItems = data.items?.length > 2 ? data.items.slice(0, 2) : data.items;
      this.header = data.header || this.header;
      this.message1 = data.message1 || this.message1;
      this.message2 = data.message2 || this.message2;
      this.acceptLabel = data.acceptLabel || this.acceptLabel;
      this.rejectLabel = data.rejectLabel || this.rejectLabel;
      this.acceptIcon = data.acceptIcon || this.acceptIcon;
      this.rejectIcon = data.rejectIcon || this.rejectIcon;
      this.action = data.action || this.action;
      this.displayAcceptButton = data.displayAcceptButton !== undefined ? data.displayAcceptButton : this.displayAcceptButton;
      this.displayRejectButton = data.displayRejectButton !== undefined ? data.displayRejectButton : this.displayRejectButton;
    }
  }

  toggleShowMore(): void {
    this.showMore = !this.showMore;
    this.displayedItems = this.showMore ? this.config.data.items : this.config.data.items.slice(0, 2);
  }

  onAccept(): void {
    this.ref.close(this.action);
  }

  onReject(): void {
    this.ref.close();
  }
}
